import api from './api';

export const getTenants = async () => {
  const response = await api.get('/tenants');
  return response.data;
};

export const getMyTenants = async () => {
  const response = await api.get('/tenants/me');
  return response.data;
};

export const selecionarTenant = async (tenantId) => {
  const response = await api.post('/tenants/selecionar', { tenantId });
  return response.data;
};
